<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Individuals</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Caregiver</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <b-modal
      id="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class="overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              v-b-modal.editModal
            />
          </div>
          <div class="pt-4">
            <p class="font-medium text-2xl text-black pt-3">
              The Individual Stress and Burnout Assessment Tool (ISBA) is an
              inventory designed by Caregiver Saathi with the purpose of
              measuring the stress level and subsequently the chances of a
              burnout of a caregiver. According to the American Psychological
              Association, burnout or caregiver burden can be understood as,
              “the stress and other psychological symptoms experienced by family
              members and other nonprofessional caregivers in response to
              looking after individuals with mental or physical disabilities,
              disorders, or diseases.” <br />
              The ISBA is designed based on the 7 elements of wellbeing, which
              are, social, psychological, physiological, financial/legal,
              creative expression and life/work purpose. The process requires a
              caregiver to answer the multiple choice questions in this
              inventory. Based on these responses we will be able to measure the
              levels of stress within these 7 areas of wellbeing, and further
              also provide an assessment of the level of burnout that is being
              experienced or can be experienced by the person. <br />
              The purpose of this tool is to pinpoint the areas of wellbeing
              that the individual needs to focus upon to improve their mental
              and physical health while being a caregiver.
            </p>
          </div>
          <div class="pt-4 hidden" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?

              <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
                <div class="flex items-center">
                  <b-form-radio
                    v-model="selected"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="A"
                    class="w-1/2"
                  >
                    <span class="font-medium text-2xl text-black"
                      >Option A</span
                    >
                  </b-form-radio>
                  <b-form-radio
                    v-model="selected"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="B"
                    class="w-1/2"
                  >
                    <span class="font-medium text-2xl text-black"
                      >Option B</span
                    ></b-form-radio
                  >
                </div>
                <div class="flex pt-3">
                  <b-form-radio
                    v-model="selected"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="C"
                    class="w-1/2"
                  >
                    <span class="font-medium text-2xl text-black"
                      >Option C</span
                    ></b-form-radio
                  >
                  <b-form-radio
                    v-model="selected"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="D"
                    class="w-1/2"
                  >
                    <span class="font-medium text-2xl text-black"
                      >Option D</span
                    ></b-form-radio
                  >
                </div>
              </b-form-group>
            </p>
          </div>
        </div>
      </div>
    </b-modal>
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <!-- banner edit -->
        <!-- <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="h-640px relative bg-white"
          />
        </div>
        <div
          class="lg:flex md:flex absolute top-28 lg:px-20 md:px-10 px-5 lg:gap-10 md:gap-10 items-center custflexdirection"
        >
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-GEK5aOw3lJaTlEj2LLWwG-1733403906"
              class="custborderradius md:block lg:block hidden"
              alt="swiper-img"
            />

            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-GEK5aOw3lJaTlEj2LLWwG-1733403906"
              class="md:hidden lg:hidden block custborderradius m-auto"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="lg:text-lg md:text-lg sm-fsize14 font-normal lg:pt-6 md:pt-3 pt-3 lh40px sm-lh20"
              >
                <i class="text-primary">
                  “If only I could get a couple of hours to paint, or go out
                  with my friends, or watch a movie without any worry. I cannot
                  trust the helper with my husband. If only someone could
                  supervise while I had this time to rejuvenate”
                </i>
                <br />- Seema, a caregiver to her husband with a terminal
                illness
              </p>
              <br />
              <p
                class="font-semibold fsize27 md-fsize18 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                We can help you find that much needed break….
              </p>
              <p
                class="fsize25 sm-fsize14 font-normal lg:pt-0 md:pt-0 pt-3 lh40px sm-lh20 mob-hidden"
              >
                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('product-services')"
                  >Shop</span
                >
              </p>
              <p
                class="fsize20px sm-fsize14 md-fsize18 font-normal lg:pt-0 md:pt-0 pt-3 lh34px sm-lh20 mob-hidden"
              >
                Our one-stop platform offers you solutions to make caregiving
                convenient for you to lead a fuller life.
              </p>
              <span
                @click="handleClick('product-services')"
                class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                >Shop</span
              >

              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick('product-services')"
                  >Explore Product & Services</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/caregiver/cg-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full w-full ml-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="lg:text-xl md:text-xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                <i>
                  “If only I could get a couple of hours to paint, or go out
                  with my friends, or watch a movie without any worry. If only
                  someone could supervise the attendant while I had this time to
                  rejuvenate” <br />- Seema, a caregiver to her father
                </i>
              </p>
              <br />
              <p
                class="font-semibold fsize27 sm-fsize26 line-h60 letter-s016px text-black leading-snug w-full"
              >
                We can help you find that much needed break….
                <span
                  @click="handleClick('community')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Identify solutions</span
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="padding btntext"
                  @click="handleClick('community')"
                  >Identify solutions</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/cg-swpr5.svg"
              class="w-full absolute min-top8rem min-h-86per md:block lg:block hidden"
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/ww-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <div class="">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-EKxPn7FApyu63CB9jeepq-1733403935"
                class="m-auto custborderradius"
                alt="swiper-img"
              />
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Caregiving is a challenging role. It takes a Village.
              </p>

              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                We are here to empower and encourage you. As a registered user
                you can get access to events, learning program and community.
                <span
                  v-b-modal.modal-1
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Subscribe</span
                >
              </p>
              <!-- @click="handleRoute('care-professionals', 'register')" -->
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext px-8"
                  @click="handleRoute"
                  >Sign Up</base-button
                >
              </div>
              <b-modal
                class="bg-primary"
                id="modal-1"
                ref="form-model"
                title="Subscribe to our newsletters"
                hide-footer
              >
                <div class="">
                  <validation-observer
                    v-slot="{ handleSubmit }"
                    ref="formValidator"
                  >
                    <b-form v-on:submit.prevent="handleSubmit(submitForm)">
                      <b-form-group
                        id="input-group-1"
                        label="Email:"
                        label-for="input-1"
                        class="mb-4"
                      >
                        <!-- <b-form-input
                        id="input-1"
                        type="email"
                        v-model="email"
                        placeholder="Enter email"
                        required
                      ></b-form-input> -->
                        <base-input
                          v-model="email"
                          id="input-1"
                          :rules="{ required: true, email: true }"
                          name="Email"
                          placeholder="Enter your email"
                          class="mb-4"
                        ></base-input>
                      </b-form-group>

                      <b-form-group
                        id="input-group-2"
                        label="Phone number:"
                        label-for="input-2"
                        class="mt-4"
                      >
                        <!-- <b-form-input
                        id="input-2"
                        type="number"
                        v-model="mobile"
                        placeholder="Enter phone number"
                      ></b-form-input> -->
                        <base-input
                          :rules="{
                            numeric: true,
                            min: 10,
                            max: 15,
                          }"
                          id="input-2"
                          name="Mobile"
                          v-model="mobile"
                          placeholder="Enter phone number"
                          class="mb-4"
                        ></base-input>
                      </b-form-group>

                      <div class="text-center mt-4">
                        <b-button type="submit" variant="primary" class=""
                          >Submit</b-button
                        >
                      </div>
                    </b-form>
                  </validation-observer>
                </div>
              </b-modal>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-EKxPn7FApyu63CB9jeepq-1733403935"
              class="m-auto custborderradius"
              alt="swiper-img"
            />
            <!-- <img
              src="../../../assets/images/swiper-img/ww-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            /> -->
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="relative h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-36 custflexdirection"
        >
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Banner3.jpg"
              class="custborderradius m-auto md:block lg:block hidden"
              alt="swiper-img"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Banner3.jpg"
              class="custborderradius md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Our community of caregivers has been there and GETS YOU…
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Lean in to share, learn and grow. As a registered user you can
                join special interest groups so that you can get tips, ideas or
                share your wisdom.

                <span
                  @click="handleClick('join-us')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Join Us</span
                >
              </p>

              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <a href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe">
                  <base-button type="primary" class="px-8 btntext">
                    Join the Support Group
                  </base-button></a
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3rlt.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="
              lg:w-1/2
              md:w-1/2
              w-full
              relative
              md:hidden
              lg:hidden
              block
              lg:top-0
              md:top-0
              top-72
            "
          >
            <img
              src="../../../assets/images/caregiver/cg-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                w-full
                ml-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  lg:text-2xl
                  md:text-2xl
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
              >
                ISBA Individual Stress and Burnout Assessment Tool
              </p>
              <p
                class="
                  font-semibold
                  fsize48
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  w-full
                "
              >
                Caregivers often neglect the impact of the role on their overall
                well-being.
              </p>
              <p
                class="
                  lg:text-2xl
                  md:text-2xl
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                  ellipsis-3
                "
              >
                Complete this test to assess your Stress and Burnout level.

                <span class="underline text-4f0a4b min-hidden font-semibold"
                  >Know more</span
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="padding btntext"
                  @click="editModal = true"
                  >Take the test</base-button
                >
        
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/cg-swpr3.svg"
              class="
                w-full
                absolute
                top6rem
                min-h-86per
                md:block
                lg:block
                hidden
              "
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/caregiver/cg-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide> -->
      <!-- 
      <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
      <!-- <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="
              min-hidden
              w-80per
              absolute
              top-0
              right-0
              line-bgh-525px
              z-index--1
            "
          /> -->
      <!-- <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/cp-bg-l.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/cg-swpr4.svg"
              class="
                w-full
                absolute
                top6rem
                min-h-86per
                -left-12
                md:block
                lg:block
                hidden
              "
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/caregiver/cg-mob-4.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div> -->
      <!-- <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                w-full
                mr-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize48
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  w-full
                "
              >
                DOWNLOAD our app.<br />
                App
              </p>
              <p
                class="
                  lg:text-2xl
                  md:text-2xl
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                "
              >
                Leverage digital technology to get assistance on your
                fingertips.
                <span class="underline text-4f0a4b hidden font-semibold"
                  >Know more</span
                >
              </p>
              <div class="flex md:pt-8 lg:pt-8 pt-4">
                <a
                  href="https://play.google.com/store/apps/details?id=com.caregiversaathi"
                  alt="playstore"
                  target="_blank"
                >
                  <img
                    src="../../../assets/images/swpr-and.svg"
                    class="md:h-16 lg:h-16 h-8 md:mr-4 lg:mr-4 mr-2"
                    alt="Download App"
                  />
                </a>

                <a
                  href="https://apps.apple.com/in/app/caregiver-saathi/id1448203556"
                  alt="playstore"
                  target="_blank"
                >
                  <img
                    src="../../../assets/images/swpr-ios.svg"
                    class="md:h-16 lg:h-16 h-8 md:ml-4 lg:ml-4 ml-2"
                    alt="Download App"
                  />
                </a>
              </div>
            </div>
          </div> -->
      <!-- </div> -->
      <!-- </swiper-slide> -->
      <div class="swiper-button-prev homeswiper" slot="button-prev"></div>
      <div class="swiper-button-next homeswiper" slot="button-next"></div>
      <div class="swiper-pagination cust-posi" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      // form: {
      //   email: "",
      //   phone: "",
      // },
      email: "",
      mobile: "",
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      editModal: false,
    };
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },

  methods: {
    handleRoute() {
      if (this.user._id) {
        this.$swal.fire({
          title: "You are already registered!",
          icon: "info",
          confirmButtonColor: "#830c81",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: ".custom-confirm-button",
          },
        });
      } else {
        this.$router.push({ name: "register" });
      }
      // this.$router.push({
      //   name: name,
      //   params: {
      //     pathName: route,
      //   },
      // });
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleScroll() {
      const el = document.getElementById("SolutionDiv");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    async submitForm() {
      let payload = {
        email: this.email,
      };

      if (!isNaN(parseInt(this.mobile))) {
        Object.assign(payload, { mobile: parseInt(this.mobile) });
      }

      // console.log(payload);

      try {
        const data = await this.$store.dispatch(
          "newsletter/createNewsletter",
          payload
        );

        if (data.code == 200) {
          this.$swal.fire({
            text: "Subscribed Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.email = "";
          this.mobile = "";
          this.$refs["form-model"].hide();
          this.$refs.formValidator.reset();
        }
      } catch (error) {
        payload = {};
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },
};
</script>
<style>
.modal-title {
  font-size: 24px !important;
  color: white;
}
.modal-header {
  background: #4f0a4b;
}

@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .homeswiper.swiper-button-next {
    right: 25px !important;
  }

  .homeswiper.swiper-button-prev {
    left: 25px !important;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
  .modal-title {
    font-size: 16px !important;
    color: white;
  }
  .sm-w-90 {
    width: 90% !important;
  }
}
.lh34px {
  line-height: 34px;
}
</style>
